import React, {
  FC,
  createContext,
  useCallback,
  useContext,
  useState,
} from 'react';

interface ChatContextType {
  openOnLoad?: boolean;
  chatOpen?: boolean;
  hadChatInteraction?: boolean;
  currentScrollTop?: number;
  chatExists?: boolean;
}

interface ChatProviderProps {
  initialState?: ChatContextType;
}

const DEFAULT_CHAT_CONTEXT = {
  openOnLoad: false,
  chatOpen: false,
  hadChatInteraction: false,
  currentScrollTop: 0,
  chatExists: false,
};

const ChatContext = createContext<{
  state: ChatContextType;
  update: (next: ChatContextType) => void;
}>({
  state: DEFAULT_CHAT_CONTEXT,
  update: () => {},
});

const useChatUIState = () => useContext(ChatContext);

const ChatProvider: FC<React.PropsWithChildren<ChatProviderProps>> = ({
  initialState,
  children,
}) => {
  const [initialChatState, setInitialState] = useState(initialState);
  const update = useCallback((next: ChatContextType) => {
    setInitialState(next);
  }, []);

  const chatContextState = {
    ...DEFAULT_CHAT_CONTEXT,
    ...initialChatState,
  };

  return (
    <ChatContext.Provider value={{ state: chatContextState, update }}>
      {children}
    </ChatContext.Provider>
  );
};

export { ChatProvider, DEFAULT_CHAT_CONTEXT };

export default useChatUIState;
